import React from "react";
import { motion } from "framer-motion";
import { CHECKOUT_URL } from "./constants";
declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}
type CtaButtonProps = {
  children: React.ReactNode;
  className?: string;
  pulse?: boolean;
};
export function CtaButton({
  children,
  className = "",
  pulse = true
}: CtaButtonProps) {
  const handleClick = () => {
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "InitiateCheckout");
    }
  };
  return <motion.a href={CHECKOUT_URL} onClick={handleClick} whileTap={{
    scale: 0.97
  }} whileHover={{
    scale: 1.02
  }} className={`group relative inline-flex w-full items-center justify-center gap-2 overflow-hidden rounded-2xl bg-brand px-5 py-4 text-center text-base font-extrabold uppercase leading-tight tracking-wide text-white shadow-lg transition-colors hover:bg-brand-dark sm:text-lg ${pulse ? "animate-pulse-cta" : ""} ${className}`} data-id="element-56" data-mp="lkfq93fj2g9d">
      <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer" data-id="element-57" data-mp="35xxt0rx2krtt" />
      <span className="relative z-10" data-id="element-58" data-mp="3a0knz1p1esv8">{children}</span>
    </motion.a>;
}